import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { sportsShowTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer';
import { useContext, useEffect, useMemo } from 'react';
import { FrameworkContext } from '../FrameworkContent';
import { ParentContext } from '../ParentContext';
import { useAppUserAccess } from './useAppUserAccess';

export const _pageNavigationTypes = {
  sport: 'sport',
  team: 'team',
  match: 'match',
  favorites: 'favorites'
}

/**
 * Used to add additional item to the page navigation vie FrameworkContext/framework_handlers/handleAdd_pageNavs
 */
export const usePageNavSports = () => {

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { additionalPageNavs } = framework_state ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { currentUserCount, lastItemCount } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { handleShow_sportsElem } = sportsSeason_handlers ?? {}

  const sportsMode = {
    organization: pathViews && pathViews.organizations && !pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    district: pathViews && pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    sport: pathViews && pathViews.sports && !pathViews.matches && !pathViews.schools && !pathViews.teams ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    school: pathViews && pathViews.schools ? true : false,
    team: pathViews && pathViews.teams ? true : false,
  }

  const handleShow_elem = (opts) => handleShow_sportsElem(opts)

  const navItem = (sportsShowType, matchKey, icon, captionPlus, noClick, adm) => {
    let _caption = _.startCase(sportsShowType)
    return {
      icon: icon ? icon : 'search',
      iconColor: adm ? 'red' : 'blue',
      caption: _caption,
      oc: !noClick && handleShow_elem,
      opts: { sportsShowType, matchKey },
      // label: captionPlus ? <Label className='sqr-box-oth' size='tiny' color={'blue'} style={{ marginRight: '2em' }}>{captionPlus}</Label> : null,
      adm
    }
  }

  const pageNavs = useMemo(() => {

    // if (!_.isEmpty(additionalPageNavs)) return;

    const pageNavs_more = []

    let navItems_news = {}

    if (pathViews.districts) {
      pageNavs_more.push(
        {
          key: 'favorites',
          caption: 'Following',
          icon: 'star',
          imsType: _pageNavigationTypes.favorites,
        }
      )
    }

    if (sportsMode.match) {
      pageNavs_more.push(
        {
          key: 'matchOptions',
          caption: 'Match Options',
          icon: 'options',
          imsType: _pageNavigationTypes.match,
        }
      )
    } else if (sportsMode.sport) {
      pageNavs_more.push(
        {
          key: 'sportsOptions',
          caption: 'Sports Options',
          icon: 'options',
          imsType: _pageNavigationTypes.sport,
        }
      )
    } else if (sportsMode.team) {
      pageNavs_more.push(
        {
          key: 'teamOptions',
          caption: 'Team Options',
          icon: 'options',
          imsType: _pageNavigationTypes.team,
        }
      )
    }

    navItems_news[sportsShowTypes.news] = navItem(sportsShowTypes.news, pathViews.matches, 'arrow right');

    return pageNavs_more

  }, [
    sportsMode.sport,
    sportsMode.match,
    isAdminOrSuper,
    currentUserCount,
    lastItemCount,
    sportsMode.team,
    pathViews,
  ]);

  useEffect(() => {
    framework_handlers.handleAdd_pageNavs(pageNavs);
  }, [pageNavs]);
};